import React from 'react';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const PlainLine = () => {
  return (
    <div
      css={{
        backgroundColor: colors.yellow,
        position: 'absolute',
        top: -46,
        height: 4,
        width: '100%',
        left: 'auto',
        '&:after': {
          content: '""',
          position: 'absolute',
          width: 15,
          height: 15,
          border: `4px solid ${colors.yellow}`,
          backgroundColor: colors.purpleDark,
          borderRadius: '50%',
          zIndex: 1,
          [mediaQueries.tabletLandscapeUp]: {
            top: '50%',
            transform: 'translateY(-50%)',
            left: 'auto',
          },
        },
      }}
    />
  );
};
export default PlainLine;
